/**
 * Portal Manta · CapexHero
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { V, fmtBR, fmtMil } from '../../globals.js';

function CapexHero({lote}){
  const tips=lote.tipologias||[];
  const tot=tips.reduce((s,t)=>s+(t.v||0),0); // R$ Mi
  const amp=tips.filter(t=>t.g==='Ampliação').reduce((s,t)=>s+(t.v||0),0);
  const pctAmp=tot?(amp/tot*100):0;
  const totalR=tot*1e6;
  const ampR=amp*1e6;
  return(<div style={{display:'grid',gridTemplateColumns:'1.2fr 1fr',gap:12,marginBottom:14}}>
    <div style={{background:'linear-gradient(135deg,#fff7ed 0%,#ffedd5 100%)',border:`2px solid ${V.or}`,borderRadius:14,padding:'14px 18px'}}>
      <div style={{fontSize:26,fontWeight:800,color:V.br,lineHeight:1.1}}>{fmtMil(totalR)}</div>
      <div style={{fontSize:10,color:V.br2,marginTop:3}}>{fmtBR(totalR)} · base {lote.data_base} · 30 anos</div>
      <div style={{fontSize:10,color:V.g5,marginTop:2}}>{lote.extensao} · {tips.length} tipologias</div>
    </div>
    <div style={{background:'linear-gradient(135deg,#eff6ff 0%,#dbeafe 100%)',border:'2px solid #2563eb',borderRadius:14,padding:'14px 18px'}}>
      <div style={{fontSize:10,color:'#1e40af',fontWeight:600,marginBottom:4}}>Ampliação</div>
      <div style={{fontSize:26,fontWeight:800,color:'#1e3a8a',lineHeight:1.1}}>{fmtMil(ampR)}</div>
      <div style={{fontSize:10,color:'#1e40af',marginTop:3}}>{pctAmp.toFixed(1)}% do CAPEX total</div>
      <div style={{height:6,background:'#dbeafe',borderRadius:3,marginTop:6}}><div style={{width:pctAmp+'%',height:'100%',background:'linear-gradient(90deg,#3b82f6,#1d4ed8)',borderRadius:3}}/></div>
    </div>
  </div>);
}

export { CapexHero };
export default CapexHero;
